/**
 * Centralized Company Information
 * All modules should import from this file.
 * To update company details, change values here — they propagate everywhere automatically.
 */

export const COMPANY = {
  name: 'Electronic City for IT Services SPC',
  legalName: 'Electronic City for IT Services SPC',
  shortName: 'eCity',
  address: {
    line1: 'Ghala Al Sanaiah',
    line2: 'Bousher',
    city: 'Muscat Governorate',
    country: 'Sultanate of Oman',
    full: 'Ghala Al Sanaiah, Bousher, Muscat Governorate, Sultanate of Oman',
  },
  website: 'www.ecityoman.com',
  email: 'hr@ecityoman.com',
  phone: '+968 2400 0000',
  logoPath: '/assets/images/logo_PNG_RGB-1787744840791.png',
  /** Full address string for use in documents */
  get addressFull() {
    return `${this.address.line1}, ${this.address.line2}, ${this.address.city}, ${this.address.country}`;
  },
  /** Short address for compact display */
  get addressShort() {
    return `${this.address.line1}, ${this.address.line2}, ${this.address.city}`;
  },
} as const;

export default COMPANY;
